var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"search-wrapper"},[_c('app-search',{on:{"enter":_vm.search}})],1),_c('users-creation-modal',{on:{"created":_vm.reloadUsersTable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }